export default {
    "type": "FeatureCollection",
    "features": [

        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.24412343,
                            25.11203337
                        ],
                        [
                            99.24623345,
                            25.11151723
                        ],
                        [
                            99.24642116,
                            25.11215074
                        ],
                        [
                            99.24718906,
                            25.11483925
                        ],
                        [
                            99.24785457,
                            25.11734228
                        ],
                        [
                            99.24867368,
                            25.12047875
                        ],
                        [
                            99.24972805,
                            25.12242776
                        ],
                        [
                            99.24961976,
                            25.12404569
                        ],
                        [
                            99.24461079,
                            25.12497722
                        ],
                        [
                            99.24455664,
                            25.12524687
                        ],
                        [
                            99.24293211,
                            25.12551652
                        ],
                        [
                            99.24268843,
                            25.12463402
                        ],
                        [
                            99.24241768,
                            25.12286902
                        ],
                        [
                            99.24247183,
                            25.11943708
                        ],
                        [
                            99.242174,
                            25.11701007
                        ],
                        [
                            99.24507108,
                            25.11627461
                        ],
                        [
                            99.24488155,
                            25.1153185
                        ],
                        [
                            99.2447191,
                            25.11446045
                        ],
                        [
                            99.2449357,
                            25.11433787
                        ],
                        [
                            99.24490862,
                            25.11340627
                        ],
                        [
                            99.24555843,
                            25.11321014
                        ],
                        [
                            99.2454772,
                            25.11267079
                        ],
                        [
                            99.24569381,
                            25.11227853
                        ],
                        [
                            99.24420466,
                            25.11249917
                        ],
                        [
                            99.24412343,
                            25.11203337
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 2,
                "_draw_type": "fill",
                "name": "有机蔬菜"
            },
            "id": 10489978,
            "bbox": [
                99.242174,
                25.11151723,
                99.24972805,
                25.12551652
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.2426671,
                            25.12531091
                        ],
                        [
                            99.24158087,
                            25.12535959
                        ],
                        [
                            99.24150558,
                            25.12475588
                        ],
                        [
                            99.23999274,
                            25.12498683
                        ],
                        [
                            99.23893475,
                            25.12528037
                        ],
                        [
                            99.23895181,
                            25.12566662
                        ],
                        [
                            99.23908833,
                            25.12571297
                        ],
                        [
                            99.23915658,
                            25.12583656
                        ],
                        [
                            99.23878117,
                            25.12588291
                        ],
                        [
                            99.23872997,
                            25.12620736
                        ],
                        [
                            99.23920778,
                            25.12619191
                        ],
                        [
                            99.23789382,
                            25.12642365
                        ],
                        [
                            99.23775731,
                            25.12592926
                        ],
                        [
                            99.23806447,
                            25.12583656
                        ],
                        [
                            99.23789382,
                            25.12549667
                        ],
                        [
                            99.2383375,
                            25.12538852
                        ],
                        [
                            99.23745016,
                            25.12273115
                        ],
                        [
                            99.23722833,
                            25.1224994
                        ],
                        [
                            99.23698943,
                            25.12195866
                        ],
                        [
                            99.23686999,
                            25.12164966
                        ],
                        [
                            99.23681879,
                            25.12134066
                        ],
                        [
                            99.23616343,
                            25.11994096
                        ],
                        [
                            99.24215261,
                            25.11982848
                        ],
                        [
                            99.24215262,
                            25.12261539
                        ],
                        [
                            99.2412976,
                            25.12256378
                        ],
                        [
                            99.2412691,
                            25.12173803
                        ],
                        [
                            99.24015758,
                            25.12168642
                        ],
                        [
                            99.23901756,
                            25.12184125
                        ],
                        [
                            99.23884655,
                            25.12251217
                        ],
                        [
                            99.23878955,
                            25.12336372
                        ],
                        [
                            99.23944506,
                            25.12349274
                        ],
                        [
                            99.23981557,
                            25.12411204
                        ],
                        [
                            99.24012908,
                            25.12413785
                        ],
                        [
                            99.24014616,
                            25.12348143
                        ],
                        [
                            99.24089691,
                            25.12343828
                        ],
                        [
                            99.24098033,
                            25.1239238
                        ],
                        [
                            99.24129016,
                            25.12395616
                        ],
                        [
                            99.24136166,
                            25.12383748
                        ],
                        [
                            99.24161191,
                            25.12384827
                        ],
                        [
                            99.24158808,
                            25.12406406
                        ],
                        [
                            99.24192174,
                            25.12412879
                        ],
                        [
                            99.24219583,
                            25.1242259
                        ],
                        [
                            99.24235075,
                            25.1242043
                        ],
                        [
                            99.2426671,
                            25.12531091
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 3,
                "_draw_type": "fill",
                "name": "有机蔬菜"
            },
            "id": 10489979,
            "bbox": [
                99.23616343,
                25.11982848,
                99.2426671,
                25.12642365
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.24834875,
                            25.11461374
                        ],
                        [
                            99.24830894,
                            25.11405507
                        ],
                        [
                            99.24858758,
                            25.11378475
                        ],
                        [
                            99.24838855,
                            25.1136586
                        ],
                        [
                            99.24785117,
                            25.11376673
                        ],
                        [
                            99.24765214,
                            25.11300982
                        ],
                        [
                            99.24799049,
                            25.11297377
                        ],
                        [
                            99.24812982,
                            25.1128296
                        ],
                        [
                            99.24799049,
                            25.11264938
                        ],
                        [
                            99.24755263,
                            25.11268542
                        ],
                        [
                            99.2473735,
                            25.11205466
                        ],
                        [
                            99.24699535,
                            25.11135181
                        ],
                        [
                            99.24676179,
                            25.11093098
                        ],
                        [
                            99.24810779,
                            25.11073226
                        ],
                        [
                            99.24883932,
                            25.10969893
                        ],
                        [
                            99.24764116,
                            25.10824916
                        ],
                        [
                            99.2488886,
                            25.10664541
                        ],
                        [
                            99.2491042,
                            25.10633861
                        ],
                        [
                            99.24936601,
                            25.10640833
                        ],
                        [
                            99.24964322,
                            25.10656173
                        ],
                        [
                            99.24988963,
                            25.10654779
                        ],
                        [
                            99.25021304,
                            25.10631072
                        ],
                        [
                            99.25047485,
                            25.10603181
                        ],
                        [
                            99.25049025,
                            25.10594813
                        ],
                        [
                            99.2517531,
                            25.10844436
                        ],
                        [
                            99.25216892,
                            25.10996439
                        ],
                        [
                            99.25264634,
                            25.11156806
                        ],
                        [
                            99.25286195,
                            25.11268365
                        ],
                        [
                            99.25303136,
                            25.11349245
                        ],
                        [
                            99.24834875,
                            25.11461374
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 4,
                "_draw_type": "fill",
                "name": "有机蔬菜"
            },
            "id": 10489980,
            "bbox": [
                99.24676179,
                25.10594813,
                99.25303136,
                25.11461374
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.25131739,
                            25.12438367
                        ],
                        [
                            99.25100895,
                            25.1236322
                        ],
                        [
                            99.25047277,
                            25.12234715
                        ],
                        [
                            99.25050432,
                            25.1213905
                        ],
                        [
                            99.24966851,
                            25.12109065
                        ],
                        [
                            99.24947927,
                            25.12027678
                        ],
                        [
                            99.24922696,
                            25.11887749
                        ],
                        [
                            99.24960544,
                            25.11870615
                        ],
                        [
                            99.25007855,
                            25.11827779
                        ],
                        [
                            99.24992085,
                            25.11753529
                        ],
                        [
                            99.25293294,
                            25.11693558
                        ],
                        [
                            99.25291717,
                            25.11673567
                        ],
                        [
                            99.25482535,
                            25.1163787
                        ],
                        [
                            99.25599235,
                            25.1189346
                        ],
                        [
                            99.2559135,
                            25.11986271
                        ],
                        [
                            99.25506192,
                            25.12004833
                        ],
                        [
                            99.2549673,
                            25.11990554
                        ],
                        [
                            99.25367415,
                            25.12043385
                        ],
                        [
                            99.25414489,
                            25.1208948
                        ],
                        [
                            99.25409484,
                            25.12171039
                        ],
                        [
                            99.25291881,
                            25.12127994
                        ],
                        [
                            99.25204304,
                            25.12198225
                        ],
                        [
                            99.25201801,
                            25.12286579
                        ],
                        [
                            99.25286876,
                            25.12279783
                        ],
                        [
                            99.2533692,
                            25.12340951
                        ],
                        [
                            99.25254347,
                            25.12365872
                        ],
                        [
                            99.25284373,
                            25.12417978
                        ],
                        [
                            99.25131739,
                            25.12438367
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 5,
                "_draw_type": "fill",
                "name": "有机蔬菜"
            },
            "id": 10489981,
            "bbox": [
                99.24922696,
                25.1163787,
                99.25599235,
                25.12438367
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.25290569,
                            25.11666652
                        ],
                        [
                            99.25269741,
                            25.1158487
                        ],
                        [
                            99.25309166,
                            25.11579158
                        ],
                        [
                            99.25287088,
                            25.11487772
                        ],
                        [
                            99.25159351,
                            25.11517758
                        ],
                        [
                            99.2512308,
                            25.11396385
                        ],
                        [
                            99.25299705,
                            25.11347836
                        ],
                        [
                            99.2547644,
                            25.11633343
                        ],
                        [
                            99.25290569,
                            25.11666652
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 6,
                "_draw_type": "fill",
                "name": "有机蔬菜"
            },
            "id": 10489982,
            "bbox": [
                99.2512308,
                25.11347836,
                99.2547644,
                25.11666652
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.23993623,
                            25.14351463
                        ],
                        [
                            99.24029755,
                            25.14310578
                        ],
                        [
                            99.24307517,
                            25.14443454
                        ],
                        [
                            99.24404621,
                            25.144271
                        ],
                        [
                            99.2454689,
                            25.14320799
                        ],
                        [
                            99.24630444,
                            25.14302401
                        ],
                        [
                            99.24560439,
                            25.14425056
                        ],
                        [
                            99.24664318,
                            25.14559975
                        ],
                        [
                            99.25034669,
                            25.1456202
                        ],
                        [
                            99.25041442,
                            25.14306489
                        ],
                        [
                            99.2532372,
                            25.1424925
                        ],
                        [
                            99.25407275,
                            25.14228807
                        ],
                        [
                            99.25456957,
                            25.14335109
                        ],
                        [
                            99.25490831,
                            25.14365773
                        ],
                        [
                            99.25547286,
                            25.14355551
                        ],
                        [
                            99.25565352,
                            25.14349418
                        ],
                        [
                            99.25592451,
                            25.14410746
                        ],
                        [
                            99.2575956,
                            25.14386215
                        ],
                        [
                            99.25852148,
                            25.14406658
                        ],
                        [
                            99.2590183,
                            25.14476162
                        ],
                        [
                            99.25879249,
                            25.14551798
                        ],
                        [
                            99.25928931,
                            25.14574285
                        ],
                        [
                            99.2595603,
                            25.14625391
                        ],
                        [
                            99.25956031,
                            25.14647877
                        ],
                        [
                            99.26028297,
                            25.14790972
                        ],
                        [
                            99.26028298,
                            25.14891137
                        ],
                        [
                            99.26007975,
                            25.14962684
                        ],
                        [
                            99.25904096,
                            25.14950419
                        ],
                        [
                            99.25852156,
                            25.14917712
                        ],
                        [
                            99.25793441,
                            25.14882961
                        ],
                        [
                            99.25718917,
                            25.14788928
                        ],
                        [
                            99.25678268,
                            25.14729646
                        ],
                        [
                            99.25628587,
                            25.14698982
                        ],
                        [
                            99.25606003,
                            25.14613125
                        ],
                        [
                            99.25508899,
                            25.14623346
                        ],
                        [
                            99.25499867,
                            25.14758264
                        ],
                        [
                            99.25436637,
                            25.14772574
                        ],
                        [
                            99.25319208,
                            25.14764397
                        ],
                        [
                            99.25233395,
                            25.1475622
                        ],
                        [
                            99.25079835,
                            25.14793016
                        ],
                        [
                            99.25106934,
                            25.14876828
                        ],
                        [
                            99.25120484,
                            25.14946319
                        ],
                        [
                            99.24849497,
                            25.15385808
                        ],
                        [
                            99.24759167,
                            25.15326529
                        ],
                        [
                            99.24673354,
                            25.15275426
                        ],
                        [
                            99.24630447,
                            25.15261117
                        ],
                        [
                            99.24567216,
                            25.15203881
                        ],
                        [
                            99.24519793,
                            25.15171175
                        ],
                        [
                            99.2443398,
                            25.15140513
                        ],
                        [
                            99.24363975,
                            25.15077145
                        ],
                        [
                            99.24298486,
                            25.15044438
                        ],
                        [
                            99.24271388,
                            25.15005599
                        ],
                        [
                            99.24174284,
                            25.14974937
                        ],
                        [
                            99.24106537,
                            25.14899303
                        ],
                        [
                            99.23925879,
                            25.14811404
                        ],
                        [
                            99.2383555,
                            25.14762343
                        ],
                        [
                            99.23727156,
                            25.14688752
                        ],
                        [
                            99.23993623,
                            25.14351463
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 7,
                "_draw_type": "fill",
                "name": "蓝莓"
            },
            "id": 10489983,
            "bbox": [
                99.23727156,
                25.14228807,
                99.26028298,
                25.15385808
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.24620717,
                            25.14289401
                        ],
                        [
                            99.24494601,
                            25.14222071
                        ],
                        [
                            99.24501069,
                            25.14143032
                        ],
                        [
                            99.24426693,
                            25.14081557
                        ],
                        [
                            99.2445903,
                            25.14014227
                        ],
                        [
                            99.24539874,
                            25.1398788
                        ],
                        [
                            99.24598081,
                            25.1399959
                        ],
                        [
                            99.24688625,
                            25.13932259
                        ],
                        [
                            99.2494409,
                            25.13967388
                        ],
                        [
                            99.25015232,
                            25.1389713
                        ],
                        [
                            99.25303034,
                            25.13894203
                        ],
                        [
                            99.25348306,
                            25.13900058
                        ],
                        [
                            99.25345071,
                            25.1375954
                        ],
                        [
                            99.25571432,
                            25.13698064
                        ],
                        [
                            99.25746053,
                            25.13692209
                        ],
                        [
                            99.25813962,
                            25.13870783
                        ],
                        [
                            99.25733119,
                            25.13812235
                        ],
                        [
                            99.25516459,
                            25.13809307
                        ],
                        [
                            99.25519694,
                            25.13926405
                        ],
                        [
                            99.25345072,
                            25.13932259
                        ],
                        [
                            99.25338606,
                            25.14219144
                        ],
                        [
                            99.25034635,
                            25.14286473
                        ],
                        [
                            99.24620717,
                            25.14289401
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 8,
                "_draw_type": "fill",
                "name": "蓝莓"
            },
            "id": 10489984,
            "bbox": [
                99.24426693,
                25.13692209,
                99.25813962,
                25.14289401
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.24017554,
                            25.14294526
                        ],
                        [
                            99.23787701,
                            25.14574477
                        ],
                        [
                            99.23725014,
                            25.14525297
                        ],
                        [
                            99.23658148,
                            25.14597176
                        ],
                        [
                            99.23236057,
                            25.14313442
                        ],
                        [
                            99.22914266,
                            25.14154548
                        ],
                        [
                            99.22972775,
                            25.14082668
                        ],
                        [
                            99.23110686,
                            25.14025919
                        ],
                        [
                            99.23908899,
                            25.13836757
                        ],
                        [
                            99.23921436,
                            25.13912422
                        ],
                        [
                            99.23858748,
                            25.141205
                        ],
                        [
                            99.23900539,
                            25.14230212
                        ],
                        [
                            99.24017554,
                            25.14294526
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 9,
                "_draw_type": "fill",
                "name": "蓝莓"
            },
            "id": 10489985,
            "bbox": [
                99.22914266,
                25.13836757,
                99.24017554,
                25.14597176
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.24355264,
                            25.12780772
                        ],
                        [
                            99.24326601,
                            25.12634793
                        ],
                        [
                            99.24885559,
                            25.12498545
                        ],
                        [
                            99.24907057,
                            25.12563425
                        ],
                        [
                            99.25050379,
                            25.12527741
                        ],
                        [
                            99.25218783,
                            25.12456372
                        ],
                        [
                            99.25340607,
                            25.12453128
                        ],
                        [
                            99.2529761,
                            25.12514765
                        ],
                        [
                            99.25294027,
                            25.12553693
                        ],
                        [
                            99.25362105,
                            25.12641281
                        ],
                        [
                            99.25491095,
                            25.12758064
                        ],
                        [
                            99.25190118,
                            25.12751576
                        ],
                        [
                            99.25136372,
                            25.12660745
                        ],
                        [
                            99.2507546,
                            25.12657501
                        ],
                        [
                            99.24971551,
                            25.12660745
                        ],
                        [
                            99.2486406,
                            25.12651013
                        ],
                        [
                            99.24670574,
                            25.12660745
                        ],
                        [
                            99.2458458,
                            25.12767796
                        ],
                        [
                            99.24355264,
                            25.12780772
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 10,
                "_draw_type": "fill",
                "name": "有机蔬菜"
            },
            "id": 10489986,
            "bbox": [
                99.24326601,
                25.12453128,
                99.25491095,
                25.12780772
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.24735063,
                            25.13140854
                        ],
                        [
                            99.2476731,
                            25.13088953
                        ],
                        [
                            99.25494671,
                            25.13027319
                        ],
                        [
                            99.25530502,
                            25.13150586
                        ],
                        [
                            99.25491089,
                            25.13176537
                        ],
                        [
                            99.253406,
                            25.13183024
                        ],
                        [
                            99.25254606,
                            25.13221951
                        ],
                        [
                            99.25136365,
                            25.13251145
                        ],
                        [
                            99.25057538,
                            25.13257633
                        ],
                        [
                            99.24960795,
                            25.13186268
                        ],
                        [
                            99.2484972,
                            25.13157074
                        ],
                        [
                            99.24735063,
                            25.13140854
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 11,
                "_draw_type": "fill",
                "name": "玉米"
            },
            "id": 10489987,
            "bbox": [
                99.24735063,
                25.13027319,
                99.25530502,
                25.13257633
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.23734366,
                            25.13316847
                        ],
                        [
                            99.23428961,
                            25.1302861
                        ],
                        [
                            99.23412327,
                            25.12950797
                        ],
                        [
                            99.23440053,
                            25.12918166
                        ],
                        [
                            99.2338183,
                            25.12862943
                        ],
                        [
                            99.23379058,
                            25.12830312
                        ],
                        [
                            99.23858704,
                            25.12727397
                        ],
                        [
                            99.23911381,
                            25.1278262
                        ],
                        [
                            99.24050006,
                            25.12915656
                        ],
                        [
                            99.23830977,
                            25.12938247
                        ],
                        [
                            99.24011189,
                            25.13249496
                        ],
                        [
                            99.23734366,
                            25.13316847
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 12,
                "_draw_type": "fill",
                "name": "玉米"
            },
            "id": 10489988,
            "bbox": [
                99.23379058,
                25.12727397,
                99.24050006,
                25.13316847
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.23678484,
                            25.1374145
                        ],
                        [
                            99.23620262,
                            25.13641051
                        ],
                        [
                            99.2353154,
                            25.1369627
                        ],
                        [
                            99.23465001,
                            25.13558222
                        ],
                        [
                            99.23384597,
                            25.13588342
                        ],
                        [
                            99.23318058,
                            25.13452802
                        ],
                        [
                            99.23517681,
                            25.13367462
                        ],
                        [
                            99.23672942,
                            25.13405112
                        ],
                        [
                            99.23806022,
                            25.13518062
                        ],
                        [
                            99.23853154,
                            25.13548182
                        ],
                        [
                            99.23825428,
                            25.13683721
                        ],
                        [
                            99.23678484,
                            25.1374145
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 13,
                "_draw_type": "fill",
                "name": "玉米"
            },
            "id": 10489989,
            "bbox": [
                99.23318058,
                25.13367462,
                99.23853154,
                25.1374145
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.23528768,
                            25.1369376
                        ],
                        [
                            99.23448364,
                            25.137289
                        ],
                        [
                            99.23431729,
                            25.1370882
                        ],
                        [
                            99.23398459,
                            25.13651091
                        ],
                        [
                            99.23323602,
                            25.13615951
                        ],
                        [
                            99.23251516,
                            25.13575792
                        ],
                        [
                            99.23148934,
                            25.13538142
                        ],
                        [
                            99.23312513,
                            25.13462842
                        ],
                        [
                            99.23384597,
                            25.13588342
                        ],
                        [
                            99.23462228,
                            25.13555712
                        ],
                        [
                            99.23528768,
                            25.1369376
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 14,
                "_draw_type": "fill",
                "name": "水稻"
            },
            "id": 10489990,
            "bbox": [
                99.23148934,
                25.13462842,
                99.23528768,
                25.137289
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.23843029,
                            25.13527843
                        ],
                        [
                            99.23682696,
                            25.13390868
                        ],
                        [
                            99.23565268,
                            25.13352024
                        ],
                        [
                            99.24037238,
                            25.13251848
                        ],
                        [
                            99.2409821,
                            25.13343847
                        ],
                        [
                            99.23843029,
                            25.13527843
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 15,
                "_draw_type": "fill",
                "name": "水稻"
            },
            "id": 10489991,
            "bbox": [
                99.23565268,
                25.13251848,
                99.2409821,
                25.13527843
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.24020609,
                            25.13237147
                        ],
                        [
                            99.23844707,
                            25.12942313
                        ],
                        [
                            99.24339141,
                            25.12864837
                        ],
                        [
                            99.24327255,
                            25.13006875
                        ],
                        [
                            99.24291598,
                            25.1308435
                        ],
                        [
                            99.2424881,
                            25.13168281
                        ],
                        [
                            99.24201268,
                            25.13228538
                        ],
                        [
                            99.24160858,
                            25.13207018
                        ],
                        [
                            99.24020609,
                            25.13237147
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 16,
                "_draw_type": "fill",
                "name": "甜柿"
            },
            "id": 10489992,
            "bbox": [
                99.23844707,
                25.12864837,
                99.24339141,
                25.13237147
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.24225048,
                            25.13226408
                        ],
                        [
                            99.24298739,
                            25.13116653
                        ],
                        [
                            99.24341527,
                            25.13006898
                        ],
                        [
                            99.24341528,
                            25.12897142
                        ],
                        [
                            99.24567351,
                            25.12892838
                        ],
                        [
                            99.24605384,
                            25.12886382
                        ],
                        [
                            99.24605385,
                            25.12795994
                        ],
                        [
                            99.24743255,
                            25.12791689
                        ],
                        [
                            99.24767025,
                            25.12888534
                        ],
                        [
                            99.24816944,
                            25.12882077
                        ],
                        [
                            99.24826452,
                            25.12907902
                        ],
                        [
                            99.24997602,
                            25.12890686
                        ],
                        [
                            99.24992848,
                            25.12867013
                        ],
                        [
                            99.25052274,
                            25.12845492
                        ],
                        [
                            99.25049898,
                            25.12763712
                        ],
                        [
                            99.25287605,
                            25.12757256
                        ],
                        [
                            99.25446869,
                            25.12787385
                        ],
                        [
                            99.25480148,
                            25.12776627
                        ],
                        [
                            99.25463507,
                            25.1290145
                        ],
                        [
                            99.25599002,
                            25.12849799
                        ],
                        [
                            99.25601378,
                            25.13015511
                        ],
                        [
                            99.25489655,
                            25.13021967
                        ],
                        [
                            99.24762263,
                            25.13088682
                        ],
                        [
                            99.24724229,
                            25.1314894
                        ],
                        [
                            99.24667178,
                            25.13166157
                        ],
                        [
                            99.24598243,
                            25.1313818
                        ],
                        [
                            99.24515044,
                            25.13155397
                        ],
                        [
                            99.24396189,
                            25.1318983
                        ],
                        [
                            99.24293973,
                            25.13215655
                        ],
                        [
                            99.24225048,
                            25.13226408
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 17,
                "_draw_type": "fill",
                "name": "甜柿"
            },
            "id": 10489993,
            "bbox": [
                99.24225048,
                25.12757256,
                99.25601378,
                25.13226408
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.25747237,
                            25.13688822
                        ],
                        [
                            99.25711106,
                            25.13611135
                        ],
                        [
                            99.25702074,
                            25.13521182
                        ],
                        [
                            99.25781112,
                            25.13541626
                        ],
                        [
                            99.25839826,
                            25.13517093
                        ],
                        [
                            99.2586015,
                            25.13506871
                        ],
                        [
                            99.25878215,
                            25.13613179
                        ],
                        [
                            99.25889506,
                            25.13647934
                        ],
                        [
                            99.2588499,
                            25.13684733
                        ],
                        [
                            99.25747237,
                            25.13688822
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 18,
                "_draw_type": "fill",
                "name": "甜柿"
            },
            "id": 10489994,
            "bbox": [
                99.25702074,
                25.13506871,
                99.25889506,
                25.13688822
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.25703719,
                            25.13509455
                        ],
                        [
                            99.25691103,
                            25.13495178
                        ],
                        [
                            99.2570372,
                            25.134138
                        ],
                        [
                            99.25762069,
                            25.13335276
                        ],
                        [
                            99.25792032,
                            25.13355264
                        ],
                        [
                            99.25818841,
                            25.1341951
                        ],
                        [
                            99.25820418,
                            25.13445209
                        ],
                        [
                            99.25856689,
                            25.13499461
                        ],
                        [
                            99.25779415,
                            25.1353087
                        ],
                        [
                            99.25703719,
                            25.13509455
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 19,
                "_draw_type": "fill",
                "name": "蓝莓"
            },
            "id": 10489995,
            "bbox": [
                99.25691103,
                25.13335276,
                99.25856689,
                25.1353087
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.25131628,
                            25.13884389
                        ],
                        [
                            99.2499724,
                            25.13923999
                        ],
                        [
                            99.24422184,
                            25.13810827
                        ],
                        [
                            99.24300298,
                            25.13706143
                        ],
                        [
                            99.24147159,
                            25.13694826
                        ],
                        [
                            99.24222167,
                            25.13581652
                        ],
                        [
                            99.24490942,
                            25.13536383
                        ],
                        [
                            99.24469065,
                            25.13451502
                        ],
                        [
                            99.24284673,
                            25.13454332
                        ],
                        [
                            99.24150286,
                            25.13428867
                        ],
                        [
                            99.24106532,
                            25.13369451
                        ],
                        [
                            99.24219043,
                            25.13236469
                        ],
                        [
                            99.2462533,
                            25.13148758
                        ],
                        [
                            99.24665959,
                            25.13295887
                        ],
                        [
                            99.24800346,
                            25.13403403
                        ],
                        [
                            99.25053495,
                            25.13703314
                        ],
                        [
                            99.25672302,
                            25.13519407
                        ],
                        [
                            99.25719183,
                            25.13683508
                        ],
                        [
                            99.25566044,
                            25.13686338
                        ],
                        [
                            99.25325396,
                            25.13754241
                        ],
                        [
                            99.25331647,
                            25.13892877
                        ],
                        [
                            99.25131628,
                            25.13884389
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 20,
                "_draw_type": "fill",
                "name": "烤烟"
            },
            "id": 10489996,
            "bbox": [
                99.24106532,
                25.13148758,
                99.25719183,
                25.13923999
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.24982124,
                            25.13560803
                        ],
                        [
                            99.25085273,
                            25.13511195
                        ],
                        [
                            99.25133623,
                            25.13584148
                        ],
                        [
                            99.25233549,
                            25.1353454
                        ],
                        [
                            99.25207763,
                            25.13473258
                        ],
                        [
                            99.25339922,
                            25.13449913
                        ],
                        [
                            99.25269008,
                            25.13365286
                        ],
                        [
                            99.25368934,
                            25.13315677
                        ],
                        [
                            99.25236775,
                            25.13271904
                        ],
                        [
                            99.25304467,
                            25.13210621
                        ],
                        [
                            99.25491423,
                            25.13187275
                        ],
                        [
                            99.25504316,
                            25.13257312
                        ],
                        [
                            99.25771858,
                            25.1319603
                        ],
                        [
                            99.25781528,
                            25.13266067
                        ],
                        [
                            99.25688049,
                            25.13397386
                        ],
                        [
                            99.25668708,
                            25.13496604
                        ],
                        [
                            99.25049814,
                            25.13680447
                        ],
                        [
                            99.24982124,
                            25.13560803
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 21,
                "_draw_type": "fill",
                "name": "甜柿"
            },
            "id": 10489997,
            "bbox": [
                99.24982124,
                25.13187275,
                99.25781528,
                25.13680447
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.23851645,
                            25.15741119
                        ],
                        [
                            99.238736,
                            25.15782956
                        ],
                        [
                            99.23704891,
                            25.15804921
                        ],
                        [
                            99.23696802,
                            25.15731706
                        ],
                        [
                            99.23643648,
                            25.1570242
                        ],
                        [
                            99.23611293,
                            25.15676271
                        ],
                        [
                            99.2361476,
                            25.15631296
                        ],
                        [
                            99.23608983,
                            25.15549713
                        ],
                        [
                            99.23569695,
                            25.15475451
                        ],
                        [
                            99.23634405,
                            25.154629
                        ],
                        [
                            99.23821602,
                            25.15488002
                        ],
                        [
                            99.23799646,
                            25.15693006
                        ],
                        [
                            99.23851645,
                            25.15741119
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 22,
                "_draw_type": "fill",
                "name": "甜柿"
            },
            "id": 10489998,
            "bbox": [
                99.23569695,
                25.154629,
                99.238736,
                25.15804921
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.24132441,
                            25.1568464
                        ],
                        [
                            99.23953333,
                            25.15376084
                        ],
                        [
                            99.24623548,
                            25.15584229
                        ],
                        [
                            99.2441555,
                            25.15613515
                        ],
                        [
                            99.24375106,
                            25.15639664
                        ],
                        [
                            99.24391284,
                            25.15680456
                        ],
                        [
                            99.24170574,
                            25.15733799
                        ],
                        [
                            99.24132441,
                            25.1568464
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 23,
                "_draw_type": "fill",
                "name": "甜柿"
            },
            "id": 10489999,
            "bbox": [
                99.23953333,
                25.15376084,
                99.24623548,
                25.15733799
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.22872357,
                            25.1421641
                        ],
                        [
                            99.23015722,
                            25.14294818
                        ],
                        [
                            99.23003775,
                            25.14325911
                        ],
                        [
                            99.23047082,
                            25.14340782
                        ],
                        [
                            99.23097856,
                            25.14394856
                        ],
                        [
                            99.23151617,
                            25.14440819
                        ],
                        [
                            99.23123243,
                            25.14466505
                        ],
                        [
                            99.23151617,
                            25.14494893
                        ],
                        [
                            99.23205379,
                            25.14438116
                        ],
                        [
                            99.23262126,
                            25.14475968
                        ],
                        [
                            99.23296474,
                            25.14450282
                        ],
                        [
                            99.23420424,
                            25.14538153
                        ],
                        [
                            99.2340101,
                            25.14584116
                        ],
                        [
                            99.2343237,
                            25.1460169
                        ],
                        [
                            99.23478665,
                            25.14574653
                        ],
                        [
                            99.23544374,
                            25.14628726
                        ],
                        [
                            99.23596642,
                            25.14666578
                        ],
                        [
                            99.23632483,
                            25.14640893
                        ],
                        [
                            99.23753446,
                            25.14705781
                        ],
                        [
                            99.23723579,
                            25.14796354
                        ],
                        [
                            99.23659364,
                            25.14809873
                        ],
                        [
                            99.23574241,
                            25.14878816
                        ],
                        [
                            99.23513013,
                            25.14849076
                        ],
                        [
                            99.23532427,
                            25.14809873
                        ],
                        [
                            99.23471198,
                            25.14755799
                        ],
                        [
                            99.2342341,
                            25.14795003
                        ],
                        [
                            99.23299459,
                            25.14661174
                        ],
                        [
                            99.23266605,
                            25.14653063
                        ],
                        [
                            99.23280046,
                            25.14594933
                        ],
                        [
                            99.23193429,
                            25.14605748
                        ],
                        [
                            99.23121748,
                            25.14535452
                        ],
                        [
                            99.23120255,
                            25.14500303
                        ],
                        [
                            99.23048572,
                            25.14511118
                        ],
                        [
                            99.23009745,
                            25.14462451
                        ],
                        [
                            99.22952997,
                            25.14385395
                        ],
                        [
                            99.2290521,
                            25.14336727
                        ],
                        [
                            99.22872357,
                            25.1421641
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 24,
                "_draw_type": "fill",
                "name": "烤烟"
            },
            "id": 10490000,
            "bbox": [
                99.22872357,
                25.1421641,
                99.23753446,
                25.14878816
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.22762584,
                            25.15929543
                        ],
                        [
                            99.22761045,
                            25.15887743
                        ],
                        [
                            99.22808764,
                            25.1589053
                        ],
                        [
                            99.22805686,
                            25.15871023
                        ],
                        [
                            99.22871878,
                            25.1586963
                        ],
                        [
                            99.22868799,
                            25.15858483
                        ],
                        [
                            99.22770281,
                            25.1586127
                        ],
                        [
                            99.22788754,
                            25.15774884
                        ],
                        [
                            99.22978094,
                            25.15762344
                        ],
                        [
                            99.22970397,
                            25.15703825
                        ],
                        [
                            99.22967319,
                            25.15614651
                        ],
                        [
                            99.23064298,
                            25.15575638
                        ],
                        [
                            99.23045826,
                            25.15543591
                        ],
                        [
                            99.23101242,
                            25.15522691
                        ],
                        [
                            99.23148962,
                            25.15521298
                        ],
                        [
                            99.23167434,
                            25.15546378
                        ],
                        [
                            99.23287502,
                            25.15465564
                        ],
                        [
                            99.23295199,
                            25.15531051
                        ],
                        [
                            99.23225928,
                            25.15571458
                        ],
                        [
                            99.23298277,
                            25.15710791
                        ],
                        [
                            99.2340911,
                            25.15664811
                        ],
                        [
                            99.23446054,
                            25.15758164
                        ],
                        [
                            99.23589213,
                            25.15730298
                        ],
                        [
                            99.2357382,
                            25.15830617
                        ],
                        [
                            99.23487617,
                            25.15841764
                        ],
                        [
                            99.23452212,
                            25.15763738
                        ],
                        [
                            99.23332143,
                            25.15791604
                        ],
                        [
                            99.23356772,
                            25.1585709
                        ],
                        [
                            99.23253636,
                            25.15876597
                        ],
                        [
                            99.23232085,
                            25.15815291
                        ],
                        [
                            99.23132028,
                            25.15841764
                        ],
                        [
                            99.23153578,
                            25.15891923
                        ],
                        [
                            99.23062757,
                            25.15908643
                        ],
                        [
                            99.22995025,
                            25.15917003
                        ],
                        [
                            99.22988868,
                            25.15837584
                        ],
                        [
                            99.22887272,
                            25.15845944
                        ],
                        [
                            99.22894968,
                            25.15923969
                        ],
                        [
                            99.22762584,
                            25.15929543
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 25,
                "_draw_type": "fill",
                "name": "无公害蔬菜"
            },
            "id": 10490001,
            "bbox": [
                99.22761045,
                25.15465564,
                99.23589213,
                25.15929543
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.23456778,
                            25.15746432
                        ],
                        [
                            99.23410097,
                            25.1564405
                        ],
                        [
                            99.234873,
                            25.15603422
                        ],
                        [
                            99.2342087,
                            25.15468536
                        ],
                        [
                            99.23392144,
                            25.15452285
                        ],
                        [
                            99.23341872,
                            25.15486413
                        ],
                        [
                            99.2322158,
                            25.15384029
                        ],
                        [
                            99.23212604,
                            25.15335275
                        ],
                        [
                            99.23198241,
                            25.15254017
                        ],
                        [
                            99.23620161,
                            25.15312523
                        ],
                        [
                            99.23623752,
                            25.15268644
                        ],
                        [
                            99.23591434,
                            25.15257268
                        ],
                        [
                            99.23612979,
                            25.15237766
                        ],
                        [
                            99.23688386,
                            25.15252392
                        ],
                        [
                            99.23749429,
                            25.15202007
                        ],
                        [
                            99.2373327,
                            25.15164628
                        ],
                        [
                            99.23815289,
                            25.1509747
                        ],
                        [
                            99.23855841,
                            25.15052418
                        ],
                        [
                            99.23908376,
                            25.14989013
                        ],
                        [
                            99.23938791,
                            25.14912258
                        ],
                        [
                            99.23953537,
                            25.14894738
                        ],
                        [
                            99.2402174,
                            25.14934784
                        ],
                        [
                            99.24045703,
                            25.14909756
                        ],
                        [
                            99.24087178,
                            25.1492227
                        ],
                        [
                            99.24125888,
                            25.14948133
                        ],
                        [
                            99.24154459,
                            25.14994853
                        ],
                        [
                            99.24211602,
                            25.15011538
                        ],
                        [
                            99.24243861,
                            25.1501571
                        ],
                        [
                            99.24258607,
                            25.15052418
                        ],
                        [
                            99.24218055,
                            25.15113321
                        ],
                        [
                            99.24178424,
                            25.15167549
                        ],
                        [
                            99.24129575,
                            25.15125001
                        ],
                        [
                            99.24089944,
                            25.15175058
                        ],
                        [
                            99.24124046,
                            25.15200086
                        ],
                        [
                            99.24074276,
                            25.15249308
                        ],
                        [
                            99.24054922,
                            25.15327728
                        ],
                        [
                            99.23910221,
                            25.15296026
                        ],
                        [
                            99.23906534,
                            25.15356093
                        ],
                        [
                            99.23886257,
                            25.15421166
                        ],
                        [
                            99.23720357,
                            25.1540031
                        ],
                        [
                            99.23709297,
                            25.15464548
                        ],
                        [
                            99.23631878,
                            25.1545537
                        ],
                        [
                            99.23567362,
                            25.15469552
                        ],
                        [
                            99.23561832,
                            25.15472889
                        ],
                        [
                            99.23600541,
                            25.15547138
                        ],
                        [
                            99.23606992,
                            25.15674777
                        ],
                        [
                            99.23585793,
                            25.15724832
                        ],
                        [
                            99.23456778,
                            25.15746432
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 26,
                "_draw_type": "fill",
                "name": "无公害蔬菜"
            },
            "id": 10490002,
            "bbox": [
                99.23198241,
                25.14894738,
                99.24258607,
                25.15746432
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.24668445,
                            25.14551561
                        ],
                        [
                            99.24572587,
                            25.14425801
                        ],
                        [
                            99.24639272,
                            25.14303812
                        ],
                        [
                            99.24900451,
                            25.14297524
                        ],
                        [
                            99.2490184,
                            25.14328965
                        ],
                        [
                            99.24922679,
                            25.14327707
                        ],
                        [
                            99.24919901,
                            25.1442077
                        ],
                        [
                            99.25028263,
                            25.14419513
                        ],
                        [
                            99.25029652,
                            25.14554076
                        ],
                        [
                            99.24668445,
                            25.14551561
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 27,
                "_draw_type": "fill",
                "name": "无公害蔬菜"
            },
            "id": 10490003,
            "bbox": [
                99.24572587,
                25.14297524,
                99.25029652,
                25.14554076
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.23139609,
                            25.13533447
                        ],
                        [
                            99.22850627,
                            25.13423491
                        ],
                        [
                            99.23405558,
                            25.13294576
                        ],
                        [
                            99.23483039,
                            25.13366617
                        ],
                        [
                            99.23139609,
                            25.13533447
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 28,
                "_draw_type": "fill",
                "name": "甜柿"
            },
            "id": 10490004,
            "bbox": [
                99.22850627,
                25.13294576,
                99.23483039,
                25.13533447
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.23131484,
                            25.13543892
                        ],
                        [
                            99.23254631,
                            25.13589879
                        ],
                        [
                            99.23396249,
                            25.13666525
                        ],
                        [
                            99.23439351,
                            25.13732022
                        ],
                        [
                            99.23528632,
                            25.13921543
                        ],
                        [
                            99.23427035,
                            25.13945234
                        ],
                        [
                            99.23286954,
                            25.13975891
                        ],
                        [
                            99.23048355,
                            25.14044174
                        ],
                        [
                            99.22977544,
                            25.14069258
                        ],
                        [
                            99.22959072,
                            25.14066471
                        ],
                        [
                            99.2289442,
                            25.13946631
                        ],
                        [
                            99.2275588,
                            25.13853263
                        ],
                        [
                            99.22634273,
                            25.13787766
                        ],
                        [
                            99.22589636,
                            25.13534137
                        ],
                        [
                            99.2274665,
                            25.13483968
                        ],
                        [
                            99.22829775,
                            25.13421257
                        ],
                        [
                            99.23131484,
                            25.13543892
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 29,
                "_draw_type": "fill",
                "name": "无公害蔬菜"
            },
            "id": 10490005,
            "bbox": [
                99.22589636,
                25.13421257,
                99.23528632,
                25.14069258
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.23750547,
                            25.1386809
                        ],
                        [
                            99.2369059,
                            25.13748943
                        ],
                        [
                            99.23823666,
                            25.13689369
                        ],
                        [
                            99.23877773,
                            25.13819107
                        ],
                        [
                            99.23750547,
                            25.1386809
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 30,
                "_draw_type": "fill",
                "name": "无公害蔬菜"
            },
            "id": 10490006,
            "bbox": [
                99.2369059,
                25.13689369,
                99.23877773,
                25.1386809
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.23513642,
                            25.13866766
                        ],
                        [
                            99.23444912,
                            25.13731732
                        ],
                        [
                            99.23623322,
                            25.13656272
                        ],
                        [
                            99.23706676,
                            25.13807193
                        ],
                        [
                            99.23624783,
                            25.13849556
                        ],
                        [
                            99.23610159,
                            25.13825727
                        ],
                        [
                            99.23513642,
                            25.13866766
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 31,
                "_draw_type": "fill",
                "name": "农业局水稻试验田"
            },
            "id": 10490007,
            "bbox": [
                99.23444912,
                25.13656272,
                99.23706676,
                25.13866766
            ]
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            99.23543025,
                            25.13916772
                        ],
                        [
                            99.23514454,
                            25.13865876
                        ],
                        [
                            99.23611229,
                            25.13827496
                        ],
                        [
                            99.23625053,
                            25.13852527
                        ],
                        [
                            99.23708925,
                            25.13811643
                        ],
                        [
                            99.23735652,
                            25.13858367
                        ],
                        [
                            99.23719984,
                            25.13878392
                        ],
                        [
                            99.23543025,
                            25.13916772
                        ]
                    ]
                ]
            },
            "properties": {
                "id": 32,
                "_draw_type": "fill",
                "name": "农业局蔬菜试验田"
            },
            "id": 10490008,
            "bbox": [
                99.23514454,
                25.13811643,
                99.23735652,
                25.13916772
            ]
        },

    ]
}